import { render, staticRenderFns } from "./Observability.vue?vue&type=template&id=5bd23ec7&scoped=true&"
import script from "./Observability.vue?vue&type=script&lang=js&"
export * from "./Observability.vue?vue&type=script&lang=js&"
import style0 from "./Observability.vue?vue&type=style&index=0&id=5bd23ec7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd23ec7",
  null
  
)

export default component.exports